import lodash from 'lodash';

export const sort = (
  data: any[],
  sortBy: string,
  orderBy: boolean | 'asc' | 'desc'
) => {
  return lodash.orderBy(data, [sortBy], [orderBy]);
};
